// extracted by mini-css-extract-plugin
export default {"image":"r3-z","loaded":"s3-z"};